// @flow
import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Switch, Route } from "react-router-dom";

import { Translate } from "@quantum/i18n";

import {
  carregarApp,
  erroInicializacao,
  isAppIniciada,
  getMedidasSelecionadas,
} from "../../state";

import { Spinner } from "@quantum/ui";
import { ErroCarregamento } from "../comum";
import Cabecalho from "../cabecalho";
import { AtivoInput } from "../excel";
import SelecaoFiltroTipoAtivo from "../selecaoFiltroTipoAtivo/SelecaoFiltroTipoAtivo";
import AreaEdicaoMedidas from "../edicaoMedidas/AreaEdicaoMedidas";
import AreaAdicionarMedidas from "../edicaoMedidas/AreaAdicionarMedidas";
import { SelecaoMedidas } from "../selecaoMedidas";
import MedidasSelecionadas from "../medidasSelecioandas/medidas-selecionadas";
import ModalAlerta from "../modal-alerta";
import ModalErro from "../modal-erro";
import Rodape, {
  BotaoAbrirArquivo,
  BotaoSalvarArquivo,
  BotaoEnviarMedidasParaExcel,
  BotaoLimparMedidas,
  BotaoTemplate,
} from "../rodape";
import { SelecaoPeriodoSeries } from "../series/selecaoPeriodo/SelecaoPeriodoSeries";
import { VisualizacaoSeries } from "../visualizacoesSeries";
import { PaginaArquivos, TemplatesModal } from "../arquivosMedidas";
import ModalFuncaoQtLink from "../exportarFuncao/ModalFuncaoQtLink";
import BuscaGlobal from "../busca-global";

import { App as Resultado } from "../resultado";

import "./app.css";
import "./excel-app.css";
import { BotaoTutoriais } from "@quantum/ui";
import {
  ID_CATEGORIA_TUTORIAL_VIDEO_RELATORIO,
  ID_CATEGORIA_TUTORIAL_VIDEO_SERIES,
} from "../../model";

export function RelatorioApp() {
  const dispatch = useDispatch();

  const erro = useSelector(erroInicializacao);
  const appIniciada = useSelector(isAppIniciada);

  const recarregarApp = useCallback(() => dispatch(carregarApp()), [dispatch]);

  const loading = !appIniciada && !erro;

  if (loading) return <Spinner />;

  if (erro) {
    return (
      <div className="App">
        <div className="App__erro">
          <ErroCarregamento retry={recarregarApp}>
            <Translate>configuracaoRelatorio.erroIniciarApp</Translate>
          </ErroCarregamento>
        </div>
      </div>
    );
  }

  return (
    <div className="App">
      <Switch>
        <Route path="/arquivos">
          <PaginaArquivos />
        </Route>

        <Route path="/resultado">
          <Resultado />
        </Route>

        <Route path="/">
          <Cabecalho>
            <div className="Cabecalho__busca-global">
              <BuscaGlobal />
            </div>
            <BotaoTutoriais
              url={
                "/webaxis/webaxis2/tutorial/video/tela?aba=true&categoria=" +
                ID_CATEGORIA_TUTORIAL_VIDEO_RELATORIO
              }
              label={<Translate>Comum.videoTutorial</Translate>}
            />
          </Cabecalho>
          <SelecaoFiltroTipoAtivo />
          <SelecaoMedidas />
          <AreaEdicaoMedidas />
          <hr className="SelecaoMedidas__divisoria" />
          <MedidasSelecionadas />
          <Rodape />
          <TemplatesModal />
          <ModalFuncaoQtLink />
          <ModalAlerta />
          <ModalErro />
        </Route>
      </Switch>
    </div>
  );
}

export const SeriesApp = () => {
  const dispatch = useDispatch();

  const erro = useSelector(erroInicializacao);
  const appIniciada = useSelector(isAppIniciada);

  const recarregarApp = useCallback(() => dispatch(carregarApp()), [dispatch]);

  const loading = !appIniciada && !erro;

  if (loading) return <Spinner />;

  if (erro) {
    return (
      <div className="App">
        <div className="App__erro">
          <ErroCarregamento retry={recarregarApp}>
            <Translate>configuracaoRelatorio.erroIniciarApp</Translate>
          </ErroCarregamento>
        </div>
      </div>
    );
  }

  return (
    <div className="App">
      <Switch>
        <Route path="/arquivos">
          <PaginaArquivos />
        </Route>

        <Route path="/resultado">
          <Resultado />
        </Route>

        <Route path="/">
          <Cabecalho>
            <div className="Cabecalho__busca-global">
              <BuscaGlobal />
            </div>
            <BotaoTutoriais
              url={
                "/webaxis/webaxis2/tutorial/video/tela?aba=true&categoria=" +
                ID_CATEGORIA_TUTORIAL_VIDEO_SERIES
              }
              label={<Translate>Comum.videoTutorial</Translate>}
            />
          </Cabecalho>
          <SelecaoFiltroTipoAtivo />
          <SelecaoMedidas />
          <AreaEdicaoMedidas
            semSelecaoDePeriodo
            semSelecaoDePeriodiciade
            semSelecaoDeAjusteDias
          />
          <hr className="SelecaoPeriodoSeries__divisoria" />
          <SelecaoPeriodoSeries />
          <hr className="SelecaoPeriodoSeries__divisoria" />
          <AreaAdicionarMedidas />
          <MedidasSelecionadas renomeavel={true} />
          <VisualizacaoSeries />
          <Rodape />
          <TemplatesModal />
          <ModalFuncaoQtLink />
          <ModalAlerta />
          <ModalErro />
        </Route>
      </Switch>
    </div>
  );
};

export const ExcelApp = () => {
  const dispatch = useDispatch();

  const erro = useSelector(erroInicializacao);
  const appIniciada = useSelector(isAppIniciada);
  const medidasSelecioandas = useSelector(getMedidasSelecionadas);

  const recarregarApp = useCallback(() => dispatch(carregarApp()), [dispatch]);

  const loading = !appIniciada && !erro;

  if (loading) return <Spinner />;

  if (erro) {
    return (
      <div className="App">
        <div className="App__erro">
          <ErroCarregamento retry={recarregarApp}>
            <Translate>configuracaoRelatorio.erroIniciarApp</Translate>
          </ErroCarregamento>
        </div>
      </div>
    );
  }

  return (
    <div className="App ExcelApp">
      <Switch>
        <Route path="/arquivos">
          <PaginaArquivos />
        </Route>

        <Route path="/">
          <Cabecalho>
            <div className="Cabecalho__busca-global">
              <BuscaGlobal />
            </div>
          </Cabecalho>
          <AtivoInput />
          <SelecaoFiltroTipoAtivo />
          <SelecaoMedidas />
          <AreaEdicaoMedidas />
          <AreaAdicionarMedidas />
          <TemplatesModal />
          <hr className="SelecaoMedidas__divisoria" />
          <MedidasSelecionadas renomeavel={false} />
          <div className="Rodape">
            <BotaoTemplate />
            <BotaoAbrirArquivo />
            <BotaoSalvarArquivo disabled={medidasSelecioandas.length === 0} />
            <BotaoLimparMedidas />
            <BotaoEnviarMedidasParaExcel
              disabled={medidasSelecioandas.length === 0}
            />
          </div>
          <ModalAlerta />
          <ModalErro />
        </Route>
      </Switch>
    </div>
  );
};
